import { Col, Row, Typography } from "antd";
import LoginLogsView from "../components/LoginLogsView";
import { useState } from "react";
import { Guid } from "guid-typescript";
import { SearchQuery } from "../code/search-query/search-query";

// PD-01 §21 — read-only Login Logs view. Shows every authentication
// attempt landing in UserLoginHistory. No form (search filters live inside
// ManagedGridView), no row actions (admin can't retroactively edit a login).
function LoginLogsPage() {
  const [, setSearchQuery] = useState<SearchQuery>({ conditions: [] });
  const [triggerView] = useState(Guid.create().toString());

  function onSearch(sq: SearchQuery): void {
    setSearchQuery(sq);
  }

  return (
    <Col className="relative flex flex-auto flex-col overflow-hidden overflow-y-auto">
      <Row className="sticky top-0 z-10 flex flex-row flex-wrap items-center p-4">
        <Typography.Title className="m-0 flex-auto" level={4}>
          Login Logs
        </Typography.Title>
      </Row>
      <Col className="flex flex-auto flex-col overflow-hidden p-4 pb-4 pt-0">
        <LoginLogsView trigger={triggerView} onSearch={onSearch} />
      </Col>
    </Col>
  );
}

export default LoginLogsPage;
